import React from 'react';

import { DAY_ACTION, DIRECTIVE_ACTION, MONTH_PASS_ACTION } from './params';

const FreePassBox = ({ view, teacher_name, on_action, on_month_pass }) => {
  const mp = view.month_pass || {};
  const can = (a) => view.actions.indexOf(a) !== -1;
  return (
    <div className="tp-fpd-box" data-testid="tp-pe-free-pass">
      <div className="tp-pe-fp-head">
        <b>
          Free Passes · {teacher_name} · {view.month_text}
        </b>
        <span>{view.balance_text}</span>
        {view.auto ? null : <span>Automatic placement is off</span>}
        {view.is_custom && can(DIRECTIVE_ACTION.RESET_AUTO) ? (
          <button
            type="button"
            className="tp-link"
            onClick={() => on_action(DIRECTIVE_ACTION.RESET_AUTO, '')}
          >
            Reset to automatic
          </button>
        ) : null}
      </div>
      {view.excluded_text ? (
        <div data-testid="tp-pe-free-pass-excluded">{view.excluded_text}</div>
      ) : null}
      {view.state_text ? <div>{view.state_text}</div> : null}
      {mp.removed ? (
        <div data-testid="tp-pe-month-pass-removed">
          {mp.text}
          {mp.note ? ` Reason: ${mp.note}` : ''}
        </div>
      ) : null}
      {on_month_pass && (mp.can_remove || mp.can_restore) ? (
        <div>
          <button
            type="button"
            className="tp-link"
            onClick={() =>
              on_month_pass(mp.can_remove ? MONTH_PASS_ACTION.REMOVE : MONTH_PASS_ACTION.RESTORE)
            }
          >
            {mp.can_remove
              ? "Remove this month's Free Pass Day"
              : "Give back this month's Free Pass Day"}
          </button>
        </div>
      ) : null}
      {view.needs_review ? (
        <div>This month is being recalculated; the passes shown may change.</div>
      ) : null}
      {view.unplaced_text ? (
        <div>Could not use the pass Ops placed on {view.unplaced_text}.</div>
      ) : null}
      {view.days.length ? (
        <ul className="tp-pe-days">
          {view.days.map((d) => (
            <li key={d.day_ist}>
              <span>
                {d.day_text} · {d.value_text}
                {d.held ? ` · Free Pass${d.placed_text ? ` (${d.placed_text})` : ''}` : ''}
              </span>
              {d.actions.indexOf(DAY_ACTION.REMOVE_PASS) !== -1 && can(DIRECTIVE_ACTION.REMOVE) ? (
                <button
                  type="button"
                  className="tp-link"
                  aria-label={`Remove the Free Pass from ${d.day_text}`}
                  onClick={() => on_action(DIRECTIVE_ACTION.REMOVE, d.day_ist)}
                >
                  Remove pass
                </button>
              ) : null}
              {d.actions.indexOf(DAY_ACTION.USE_PASS) !== -1 && can(DIRECTIVE_ACTION.APPLY) ? (
                <button
                  type="button"
                  className="tp-link"
                  aria-label={`Use a Free Pass on ${d.day_text}`}
                  onClick={() => on_action(DIRECTIVE_ACTION.APPLY, d.day_ist)}
                >
                  Use a pass
                </button>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

export default FreePassBox;
